import axios from 'axios'
import * as types from '../mutation-types'

import {
  sortBy,
  filter,
  uniqWith,
  getObjectValue,
  createTheParametersOfTheUrl,
} from '../../plugins/helper'
const { objectToFormData } = require('../../plugins/objectToFormData')

const defaultPagination = {
  count: 0,
  current_page: 1,
  links: {},
  per_page: 0,
  total: 0,
  total_pages: 0,
}

let cancelTokenSourceRoomActiveMessages = null
let cancelTokenSourceRoomMessagesLog = null

// state
export const state = {
  loading: false,
  roomMessages: [],
  roomMessagesPagination: defaultPagination,
  error: null,
  loadingAddRoomMessages: false,
  addRoomMessages: null,
  errorAddRoomMessages: null,
  loadingUpdateStatusRoomMessages: false,
  updateStatusRoomMessages: null,
  errorUpdateStatusRoomMessages: null,
  updateReaction: null,
  loadingUpdateReaction: false,
  errorUpdateReaction: null,
  roomActiveLoading: false,
  roomActiveMessages: [],
  roomActiveMessagesIds: new Set(),
  roomActivePagination: defaultPagination,
  roomActiveError: null,
}

// mutations
export const mutations = {
  [types.GET_ROOM_MESSAGES_START](state) {
    state.loading = true
    state.roomMessages = []
    state.roomMessagesPagination = defaultPagination
    state.error = null
  },

  [types.GET_ROOM_MESSAGES_SUCCESS](state, { sid, data, pagination }) {
    const tmpData = [].concat(data, state.roomMessages)
    const result = sortBy(tmpData, [function (ob) {
      return ob._id
    }], ['desc'])
    state.loading = false
    const filterResult = filter(result, function (ob) {
      return ob.roomId === sid
    })
    state.roomMessages = uniqWith(filterResult, function (arrVal, othVal) {
      return arrVal._id === othVal._id
    })
    state.roomMessagesPagination = pagination
    state.error = null
  },

  [types.GET_ROOM_MESSAGES_ERROR](state, { error }) {
    state.loading = false
    state.roomMessages = []
    state.roomMessagesPagination = defaultPagination
    state.error = error
  },

  [types.GET_ADD_ROOM_MESSAGES_START](state) {
    state.loadingAddRoomMessages = true
    state.addRoomMessages = null
    state.errorAddRoomMessages = null
  },

  [types.GET_ADD_ROOM_MESSAGES_SUCCESS](state, { data }) {
    state.loadingAddRoomMessages = false
    state.addRoomMessages = data
    state.errorAddRoomMessages = null
  },

  [types.GET_ADD_ROOM_MESSAGES_ERROR](state, { error }) {
    state.loadingAddRoomMessages = false
    state.addRoomMessages = null
    state.errorAddRoomMessages = error
  },

  [types.GET_UPDATE_STATUS_TO_SEEN_START](state) {
    state.loadingUpdateStatusRoomMessages = true
    state.updateStatusRoomMessages = null
    state.errorUpdateStatusRoomMessages = null
  },

  [types.GET_UPDATE_STATUS_TO_SEEN_SUCCESS](state, { data }) {
    state.loadingUpdateStatusRoomMessages = false
    state.updateStatusRoomMessages = data
    state.errorUpdateStatusRoomMessages = null
  },

  [types.GET_UPDATE_STATUS_TO_SEEN_ERROR](state, { error }) {
    state.loadingUpdateStatusRoomMessages = false
    state.updateStatusRoomMessages = null
    state.errorUpdateStatusRoomMessages = error
  },

  [types.UPDATE_REACTION_START](state) {
    state.loadingUpdateReaction = true
    state.updateReaction = null
    state.errorUpdateReaction = null
  },

  [types.UPDATE_REACTION_SUCCESS](state, { data }) {
    state.loadingUpdateReaction = false
    state.updateReaction = data
    state.errorUpdateReaction = null
  },

  [types.UPDATE_REACTION_ERROR](state, { error }) {
    state.loadingUpdateReaction = false
    state.updateReaction = null
    state.errorUpdateReaction = error
  },

  [types.GET_ROOM_ACTIVE_MESSAGES_START](state) {
    state.roomActiveLoading = true
    state.roomActiveMessages = []
    state.roomActiveMessagesIds = new Set()
    state.roomActivePagination = defaultPagination
    state.roomActiveError = null
  },

  [types.GET_ROOM_ACTIVE_MESSAGES_SUCCESS](state, { sid, data, pagination }) {
    const tmpData = [].concat(data, state.roomActiveMessages)
    const result = sortBy(tmpData, [function (ob) {
      return ob._id
    }], ['desc'])
    const filterResult = filter(result, function (ob) {
      return ob.roomId === sid
    })
    state.roomActiveLoading = false
    state.roomActiveMessages = uniqWith(filterResult, function (arrVal, othVal) {
      return arrVal._id === othVal._id
    })
    state.roomActiveMessages.forEach((message) => {
      if (!state.roomActiveMessagesIds.has(message._id)) {
        state.roomActiveMessagesIds.add(message._id)
      }
    })
    state.roomActivePagination = pagination
    state.roomActiveError = null
  },

  [types.GET_ROOM_ACTIVE_MESSAGES_ERROR](state, { error }) {
    state.roomActiveLoading = false
    state.roomActiveMessages = []
    state.roomActiveMessagesIds = new Set()
    state.roomActivePagination = defaultPagination
    state.roomActiveError = error
  },
}

export const actions = {
  async getRoomMessages({ commit }, { sid, params }) {
    try {
      if (cancelTokenSourceRoomMessagesLog && params && params.page === 1) {
        cancelTokenSourceRoomMessagesLog.cancel('Operation canceled due to new request.')
      }
      cancelTokenSourceRoomMessagesLog = axios.CancelToken.source()
      const href = createTheParametersOfTheUrl({...params, order_direction: 'desc', order_column: 'id'})
      const { data } = await axios.get(`/api/sale/conversations/${sid}/messages${href}`, { cancelToken: cancelTokenSourceRoomMessagesLog.token })
      const pagination = getObjectValue(data, 'meta.pagination')
      commit(types.GET_ROOM_MESSAGES_SUCCESS, { sid, data: data.data, pagination })
    } catch (e) {
      if (axios.isCancel(e)) {
        console.log('Request canceled', e.message)
      } else {
        commit(types.GET_ROOM_MESSAGES_ERROR, { error: e })
      }
    }
  },
  async getRoomActiveMessages({ commit }, { sid, params }) {
    try {
      if (cancelTokenSourceRoomActiveMessages && params && params.page === 1) {
        cancelTokenSourceRoomActiveMessages.cancel('Operation canceled due to new request.')
      }
      cancelTokenSourceRoomActiveMessages = axios.CancelToken.source()
      const href = createTheParametersOfTheUrl({...params, order_direction: 'desc', order_column: 'id'})
      const { data } = await axios.get(`/api/sale/messages/${sid}${href}`, { cancelToken: cancelTokenSourceRoomActiveMessages.token })
      const pagination = getObjectValue(data, 'meta.pagination')
      commit(types.GET_ROOM_ACTIVE_MESSAGES_SUCCESS, { sid, data: data.data, pagination })
    } catch (e) {
      if (axios.isCancel(e)) {
        console.log('Request canceled', e.message)
      } else {
        commit(types.GET_ROOM_ACTIVE_MESSAGES_ERROR, { error: e })
      }
    }
  },
  async addRoomMessages({ commit }, { sid, params }) {
    try {
      commit(types.GET_ADD_ROOM_MESSAGES_START)
      const form = objectToFormData(params)
      const { data } = await axios.post(`/api/sale/messages/${sid}`, form)

      commit(types.GET_ADD_ROOM_MESSAGES_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_ADD_ROOM_MESSAGES_ERROR, { error: e })
    }
  },
  async updateStatusToSeen({ commit }, { sid, params }) {
    try {
      commit(types.GET_UPDATE_STATUS_TO_SEEN_START)
      const form = objectToFormData(params)
      const { data } = await axios.post(`/api/sale/messages/${sid}/update_to_read`, form)

      commit(types.GET_UPDATE_STATUS_TO_SEEN_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_UPDATE_STATUS_TO_SEEN_ERROR, { error: e })
    }
  },
  async eventUpdateReaction({ commit }, { roomId, messageId, reaction, remove }) {
    try {
      commit(types.UPDATE_REACTION_START)
      const form = objectToFormData({ reaction: getObjectValue(reaction, 'unicode'), remove })
      const { data } = await axios.post(`/api/sale/messages/${roomId}/${messageId}/update_reactions`, form)

      commit(types.UPDATE_REACTION_SUCCESS, { data })
    } catch (e) {
      commit(types.UPDATE_REACTION_ERROR, { error: e })
    }
  },
}

// getters
export const getters = {
  loadingRoomMessages: state => state.loading,
  roomMessages: state => state.roomMessages,
  errorRoomMessages: state => state.error,
  loadingAddRoomMessages: state => state.loadingAddRoomMessages,
  addRoomMessages: state => state.addRoomMessages,
  errorAddRoomMessages: state => state.errorAddRoomMessages,
  loadingUpdateStatusRoomMessages: state => state.loadingUpdateStatusRoomMessages,
  updateStatusRoomMessages: state => state.updateStatusRoomMessages,
  errorUpdateStatusRoomMessages: state => state.errorUpdateStatusRoomMessages,
  updateReaction: state => state.updateReaction,
  loadingUpdateReaction: state => state.loadingUpdateReaction,
  errorUpdateReaction: state => state.errorUpdateReaction,
  roomActiveLoading: state => state.roomActiveLoading,
  roomActiveMessages: state => state.roomActiveMessages,
  roomActiveMessagesIds: state => state.roomActiveMessagesIds,
  roomActivePagination: state => state.roomActivePagination,
  roomActiveError: state => state.roomActiveError,
  roomMessagesPagination: state => state.roomMessagesPagination,
}
